// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"2b035a29","84":"fc1e09ab","247":"f833e738","627":"f911c7d2","834":"5ccc839d","867":"3e2e6046","923":"0dff08a4"}[chunkId] + ".chunk.js";
};